// extracted by mini-css-extract-plugin
module.exports = {"cooperateConent":"O8suZb83","exclusiveColor":"zi26iqa4","container":"cFTmqy8a","slider":"__2aov6ngn","cooperateCard":"nE8GcBAt"};